import {clipboardSvg as Icon__small__clipboardSvg} from '../Icon__small/Icon__small--clipboard.js';
import {clipboardSvg as Icon__xsmall__clipboardSvg} from '../Icon__xsmall/Icon__xsmall--clipboard.js';

export var clipboard = {
  name: 'clipboard',
  category: 'icon',
  colorable: true,
  svg: Icon__small__clipboardSvg,
  alt: {
    Icon__small: Icon__small__clipboardSvg,
    Icon__xsmall: Icon__xsmall__clipboardSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
